<template>
  <div class="house">
    <div class="suc-img">
      <img src="../assets/logo1.png">
    </div>
    <div class="add-house">
      <button @click="getCode()">进入系统</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data () {
    return {
      assign: true, // 去认证
      communityInfo: [],
      v_token:'',
      redirect_uri:'',
      appid:'wxfc2bd51fdc6838c8',//优狐科技的id
      secret:'9b4ad1f2a8442d00f658a1e497abf0d3',//优狐科技
      property_token:''
    }
  },
  created(){
       let uri_params = this.getRequest();
       let code = uri_params['code'];
       if(typeof(code) != 'undefined'){
          this.getToken(code);
       }
  },
  methods: {
    getCode(){
      this.redirect_uri = 'https://wx.loulilouwai.com.cn/#/?f_name='+this.$route.query.f_name+'&token='+this.$route.query.token+'&property_token='+this.$route.query.property_token+'&city_id='+this.$route.query.city_id;
      this.redirect_uri =  this.urlencode(this.redirect_uri);
      var url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid="+this.appid+'&redirect_uri='+this.redirect_uri+'&response_type=code&scope=snsapi_userinfo&state=124#wechat_redirect';
      window.location.href = url;

    },
    getRequest(){
       let url = location.search;
       let theRequest = new Object();
       if(url.indexOf('?') != -1){
           let str = url.substr(1);
           let strs = str.split('&');
           for(let i=0;i<strs.length;i++){
              theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
           }
       }
       return theRequest;
    },
    getToken(code){
        let url = 'sns/oauth2/access_token?appid='+this.appid+'&secret='+this.secret+'&code='+code+'&grant_type=authorization_code';
          this.axios.get(url).then((res)=>{
              let openId = res.data.openid;
              let access_token = res.data.access_token;
              this.getWeiXinInfo(access_token,openId);

          });
    },
    getWeiXinInfo(access_token,openId){
      let url = 'sns/userinfo?access_token='+access_token+'&openid='+openId+'&lang=zh_CN';
      this.axios.get(url).then((res)=>{
         let unionId = res.data.unionid;
         let nickName = res.data.nickname;
         if( typeof(unionId) != 'undefined'){
            this.getUserId(unionId,nickName);
         }else{
            history.go(-1);
            // this.$toast({
            //    message:'该公众号信息暂不支持该功能，请在公众号留言反馈此信息',
            //    position:'bottom',
            //    duration:'3000'
            // });
         }
      });
    },
    getUserId(unionId,nickName){
        this.$indicator.open();
        let data = JSON.stringify({'union_id':unionId,'third_name':nickName});
        this.axios.get('/jmobile/Register/register_wechat/json/'+data).then((res)=>{
            this.$indicator.close();
            if(res.data.status == '1'){
                let userId = res.data.data.user_uid;
                let f_name = this.$route.query.f_name;
                let token = this.$route.query.token;

                window.location.href = 'https://wx.loulilouwai.com.cn/#/'+f_name+'?userId='+userId+'&token='+token+'&property_token='+this.$route.query.property_token+'&city_id='+this.$route.query.city_id;
            }else{
              this.$toast({
                message:res.data.info,
                position:'bottom',
                duration:'2000'
              });
            }
        }).catch((response)=>{
            this.$toast({
              message:'网络错误',
              position:'bottom',
              duration:'2000'
            });
        });
    },
    urlencode(clearString){
          var output = '';
          var x = 0;
           
          clearString = utf16to8(clearString.toString());
          var regex = /(^[a-zA-Z0-9-_.]*)/;
       
          while (x < clearString.length) 
          {
              var match = regex.exec(clearString.substr(x));
              if (match != null && match.length > 1 && match[1] != '') 
              {
                  output += match[1];
                  x += match[1].length;
              } 
              else
              {
                  if (clearString[x] == ' ')
                      output += '+';
                  else
                  {
                      var charCode = clearString.charCodeAt(x);
                      var hexVal = charCode.toString(16);
                      output += '%' + ( hexVal.length < 2 ? '0' : '' ) + hexVal.toUpperCase();
                  }
                  x++;
              }
          }
       
          function utf16to8(str) 
          {
              var out, i, len, c;
       
              out = "";
              len = str.length;
              for(i = 0; i < len; i++) 
              {
                  c = str.charCodeAt(i);
                  if ((c >= 0x0001) && (c <= 0x007F)) 
                  {
                      out += str.charAt(i);
                  } 
                  else if (c > 0x07FF) 
                  {
                      out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F));
                      out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F));
                      out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
                  } 
                  else
                  {
                      out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F));
                      out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
                  }
              }
              return out;
          }
       
          return output;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  .house{
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #f5f5f5;
    .suc-img img{
      width: 150px;
      position:absolute;
      top:40%;
      left:50%;
      margin:-75px 0 0 -70px;
    }
    .add-house{
      position: absolute;
      box-sizing: border-box;
      height: 45px;
      bottom: 40px;
      left: 0;
      padding: 0 16px 0 14px;
      width: 100%;
      button{
        width: 100%;
        height: 45px;
        line-height: 45px;
        text-align: center;
        color: #fff;
        background-color: #ffaf14;
        border-radius: 5px;
        font-size: 18px;
      }
    }
  }
  </style>




// WEBPACK FOOTER //
// src/components/Index.vue